import { LOADERS_ACTIONS } from 'containers/AppContainer/Loader/constants';
import { LoadingAction } from 'containers/AppContainer/Loader/action';
import { RESET_STORE } from 'containers/LoginPage/constants';

const initialState = {
  GLOBAL: false,
};

const loadersReducer = (state = initialState, action: LoadingAction) => {
  switch (action.type) {
    case LOADERS_ACTIONS.START: {
      return { ...state, [action.loaderKey]: true };
    }
    case LOADERS_ACTIONS.STOP:
      return { ...state, [action.loaderKey]: false };
    case RESET_STORE:
      return { ...initialState };
    default:
      return state;
  }
};

export default loadersReducer;
